import { AeoPromptTagSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod/v4";

export const getAeoPromptTags = {
  name: "getAeoPromptTags" as const,
  input: z.object({}),
  output: z.object({
    tags: z.array(AeoPromptTagSchema.extend({ promptCount: z.number() })),
  }),
};
